import { render, staticRenderFns } from "./PayoutsToSubmitMiniCard.vue?vue&type=template&id=21c690c4&"
import script from "./PayoutsToSubmitMiniCard.vue?vue&type=script&lang=js&"
export * from "./PayoutsToSubmitMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports